
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */

.toggle-container {

  margin: 1rem;

  display: flex;

  gap: 1rem;

  vertical-align: middle;
}

  .toggle-container span {

  font-size: var(--fs-sm);

  line-height: var(--lh-sm)
}

  .toggle-container span {

  line-height: 1
}

  .toggle-container span {

  color: var(--blue-responsible-main)
}

  .toggle-container .toggle {

  position: relative
}

  .toggle-container .toggle {

  height: 1rem
}

  .toggle-container .toggle {

  width: 2.5rem
}

  .toggle-container .toggle {

  cursor: pointer
}

  .toggle-container .toggle {

  border-radius: 1.5rem
}

  .toggle-container .toggle {

  background-color: var(--blue-responsible-main)
}

  .toggle-container .toggle .circle {

  position: absolute
}

  .toggle-container .toggle .circle {

  bottom: 50%
}

  .toggle-container .toggle .circle {

  height: 1.5rem
}

  .toggle-container .toggle .circle {

  width: 1.5rem
}

  .toggle-container .toggle .circle {

  --tw-translate-y: 50%;

  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))
}

  .toggle-container .toggle .circle {

  border-radius: 9999px
}

  .toggle-container .toggle .circle {

  border-width: 1.5px
}

  .toggle-container .toggle .circle {

  border-style: solid
}

  .toggle-container .toggle .circle {

  border-color: var(--blue-responsible-main)
}

  .toggle-container .toggle .circle {

  background-color: var(--neutral-white)
}

  .toggle-container .toggle .circle {

  transition-property: all;

  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  transition-duration: 150ms
}

  .toggle-container.show-less .circle {

  left: -2px
}

  .toggle-container.show-less .circle {

  right: 100%
}

  .toggle-container.show-less span:first-child {

  -webkit-text-decoration-line: underline;

          text-decoration-line: underline
}

  .toggle-container.show-more .circle {

  right: -2px
}

  .toggle-container.show-more .circle {

  left: 50%
}

  .toggle-container.show-more span:last-child {

  -webkit-text-decoration-line: underline;

          text-decoration-line: underline
}`;